import {Component, OnDestroy, OnInit} from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import * as fromPayment from '../../store/payment.reducers';
import * as fromProfile from '../../../profile/store/profile.reducers';
import * as fromUser from '../../../user/store/user.reducers';
import {Cookie} from '../../../helper/cookie';
import {User} from '../../../user/user.model';
import {Options} from '@angular-slider/ngx-slider';
import {Store} from '@ngrx/store';
import * as fromApp from '../../../store/app.reducers';
import {ShortcutNumbersPipe} from '../../../helper/shortcut-numbers.pipe';
import {Router} from '@angular/router';
import {CustomStepDefinition} from '@angular-slider/ngx-slider/options';
import * as PaymentActions from '../../store/payment.actions';

@Component({
    selector: 'app-pricing-quantity',
    templateUrl: './pricing-quantity.component.html',
    styleUrls: ['./pricing-quantity.component.scss'],
    standalone: false
})
export class PricingQuantityComponent implements OnInit, OnDestroy {

  paymentState: Observable<fromPayment.State>;
  profileState: Observable<fromProfile.State>;
  userState: Observable<fromUser.State>;
  paymentSubscription: Subscription;
  profileSubscription: Subscription;
  userSubscription: Subscription;
  loading: boolean;
  cookie: Cookie;
  user: User;
  loadPricing: boolean;
  subscriptionPeriod = 2;

  followersSlider = 10000;
  options: Options = {
    floor: 0,
    ceil: 20000000,
    showTicks: true,
    showTicksValues: false,
    stepsArray: []
  };

  constructor(
    private store: Store<fromApp.AppState>,
    private shortcutNumbersPipe: ShortcutNumbersPipe,
    private router: Router
  ) {
    this.cookie = new Cookie();
    this.loadPricing = true;
  }

  ngOnInit() {
    this.paymentState = this.store.select('payment');
    this.profileState = this.store.select('profile');
    this.userState = this.store.select('user');

    this.userSubscription = this.store.select('user').subscribe(
      (userState: fromUser.State) => {
        if (userState.user !== null) {
          this.user = userState.user;
          if (this.loadPricing) {
            this.onLoadPricing();
            this.loadPricing = false;
          }
        }
      }
    );

    this.profileSubscription = this.store.select('profile').subscribe(
      (state: fromProfile.State) => {
        const waitingForPricing = setInterval(() => {
          if (state.profileDetail !== null) {
            for (const i in this.options.stepsArray) {
              const value = this.options.stepsArray[i];
              const followersCount = Math.min(20000000, state.profileDetail.followed_by);
              if (followersCount <= value.value) {
                this.followersSlider = value.value;
                break;
              }
            }

          }
          if (this.options.stepsArray.length > 0) {
            clearInterval(waitingForPricing);
          }
        }, 300);

      }
    );

    this.paymentSubscription = this.store.select('payment').subscribe(
      (state: fromPayment.State) => {
        const that = this;
        if (state.pricing.length > 0) {
          const stepsArray = state.pricing
            .filter(value =>
              value.permissions['auditor.limit'] !== undefined
              && value.permissions['auditor.limit'].followers_count !== undefined
              && value.permissions['auditor.limit'].followers_count > 0
            ).map(value => new class implements CustomStepDefinition {
              legend: string = that.shortcutNumbersPipe.transform(
                value.permissions['auditor.limit'].followers_count
              );
              value = value.permissions['auditor.limit'].followers_count;
            })
          ;
          this.options = {
            floor: 0,
            ceil: 1000000,
            showTicks: true,
            showTicksValues: false,
            stepsArray: stepsArray
          };
        }
      }
    );
  }

  onLoadPricing() {
    const pricingType = this.getPricingType();
    this.store.dispatch(
      new PaymentActions.GetPricing({
        params: {
          type: pricingType
        }
      })
    );
  }

  getPricingType(): number {
    if (this.user.type === 1) {
      if (this.subscriptionPeriod === 1) {
        return 3;
      } else if (this.subscriptionPeriod === 2) {
        return 5;
      } else {
        return 1;
      }
    } else if (this.user.type === 2) {
      if (this.subscriptionPeriod === 1) {
        return 4;
      } else if (this.subscriptionPeriod === 2) {
        return 6;
      } else {
        return 2;
      }
    } else if (this.user.type === 0) {
      if (this.subscriptionPeriod === 1) {
        return 4;
      } else if (this.subscriptionPeriod === 2) {
        return 6;
      } else {
        return 2;
      }
    }
    return 2;
  }

  getMinValue(value, minValue) {
    return Math.min(value, minValue);
  }

  setSubscriptionPeriod(period: number) {
    this.subscriptionPeriod = period;
    this.onLoadPricing();
  }

  ngOnDestroy(): void {
    this.paymentSubscription.unsubscribe();
    this.profileSubscription.unsubscribe();
    this.userSubscription.unsubscribe();
  }

}
